/* One server-rendered rule across product, collection, cart and drawer. */
(()=>{
 let timer,inFlight=false,pending=false,adding=false;
 async function refresh(){
  if(inFlight){pending=true;return;}if(!document.querySelector('.lv36-live'))return;
  inFlight=true;
  try{
   /* lv62 yol (2026-10-08): adres DIL KOKU degil MEVCUT SAYFA.
      Onceki surum `window.Shopify.routes.root` kullaniyordu, yani `/` veya `/ru`
      — ANA SAYFA. Shopify o adresi index olarak isliyordu, dolayisiyla bolumun
      icinde collection / product / request.page_type / request.path YANLIS
      geliyordu. Ilk boyama dogruydu, 180 ms sonra bu istek onu ana sayfa
      surumuyle degistiriyordu. Olculdu (2026-10-08, /collections/toate-parfumurile):
        sunucu HTML  ptype=collection  chandle=toate-parfumurile   DOGRU
        tarayici DOM ptype=index       chandle=(bos)               YANLIS
      location.pathname dil onekini zaten tasir (/ru/...), kok EKLENMEZ.
      Dogrulandi: bolum 5 sayfa tipinde de dort yerlesimi birlikte basiyor,
      asagidaki dongu hicbirini kaybetmiyor.
      Yedek: tema-yedek/2026-10-08/aday-ONCE/lv33-commerce-ONCE.js */
   const yol=location.pathname||(window.Shopify?.routes?.root||'/');
   const response=await fetch(yol+'?section_id=lv36-gift-state',{headers:{Accept:'text/html'},cache:'no-store'});
   if(!response.ok)throw Error('state');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');
   for(const place of ['pdp','cart','drawer','collection']){
    const selector='.lv36-live[data-lv36-placement="'+place+'"]',fresh=doc.querySelector(selector);
    if(!fresh)continue;
    document.querySelectorAll(selector).forEach(current=>{
     const focused=current.contains(document.activeElement),active=document.activeElement;
     const focusVariant=focused?active?.dataset?.lv33Add:null;
     const wasOpen=current.querySelector('.lv37-picker')?.open;
     const scroll=current.querySelector('.lv37-carousel')?.scrollLeft||0;
     const previousStage=current.querySelector('.lv37')?.dataset.stage;
     current.innerHTML=fresh.innerHTML;
     const sameStage=previousStage===current.querySelector('.lv37')?.dataset.stage;
     const picker=current.querySelector('.lv37-picker');
     if(sameStage&&picker&&wasOpen!==undefined)picker.open=wasOpen;
     if(sameStage&&current.querySelector('.lv37-carousel'))current.querySelector('.lv37-carousel').scrollLeft=scroll;
     if(focused){const target=focusVariant&&current.querySelector('[data-lv33-add="'+focusVariant+'"]')||current.querySelector('.lv37-cta')||current.querySelector('.lv37-status');if(target){if(!target.matches('a,button'))target.tabIndex=-1;target.focus({preventScroll:true});}}
    });
   }
  }catch(error){/* A failed read must not turn into a second cart mutation. */}
  finally{inFlight=false;if(pending){pending=false;schedule();}}
 }
 function schedule(){clearTimeout(timer);timer=setTimeout(refresh,180);}
 document.addEventListener('click',async event=>{
  const reveal=event.target.closest('[data-lv43-reveal]');if(reveal){const picker=reveal.closest('.lv37')?.querySelector('.lv37-picker');if(picker){event.preventDefault();picker.open=true;picker.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});picker.querySelector('button,a')?.focus({preventScroll:true});return;}}
 const button=event.target.closest('[data-lv33-add]');if(!button||adding)return;
  event.preventDefault();const box=button.closest('.lv37'),status=box.querySelector('[role=alert]'),label=button.textContent;
  adding=true;document.querySelectorAll('[data-lv33-add]').forEach(b=>b.disabled=true);button.textContent=button.dataset.loading;if(status)status.hidden=true;
  try{
   const drawer=document.querySelector('cart-drawer');
   const sectionIds=drawer?.getSectionsToRender?.().map(section=>section.id)||['cart-icon-bubble'];
   const response=await fetch(button.dataset.url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.lv33Add),quantity:1}],sections:sectionIds,sections_url:location.pathname})});
   const data=await response.json();if(!response.ok||data.status||!data.items?.length)throw Error('unconfirmed');
   /* The full cart must update totals and gift discount together. */
   if(box.closest('[data-lv36-placement="cart"]')){location.reload();return;}
   if(drawer?.renderContents&&data.sections){drawer.setActiveElement?.(button);drawer.renderContents(data);}
   document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'lv37-campaign'}}));
   await refresh();
  }catch(error){if(status)status.hidden=false;button.textContent=label;}
  finally{adding=false;document.querySelectorAll('[data-lv33-add]').forEach(b=>b.disabled=false);}
 });
 function init(){
  // PDP, home and collection campaign markup already contains the server-rendered cart state.
  // Keep all cart-update, drawer, back/forward and tab-return refreshes below.
  if(!document.querySelector('[data-lv29], #product-grid')&&!document.body.classList.contains('template-index'))schedule();
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,schedule);
  ['cart:refresh','cart:updated','cart-drawer:open','ajaxCart.afterCartLoad'].forEach(name=>document.addEventListener(name,schedule));
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')schedule();});
  window.addEventListener('pageshow',event=>{if(event.persisted)schedule();});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
